var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_123_3563",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_123_3563)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.23741 11.4574C9.06923 9.34056 12.2912 7.945 13.9033 7.27074C18.5063 5.34558 19.4627 5.01116 20.0861 5.00012C20.2232 4.99769 20.5298 5.03186 20.7284 5.19389C20.8961 5.33071 20.9422 5.51553 20.9643 5.64524C20.9864 5.77496 21.0139 6.07046 20.992 6.30136C20.7426 8.93675 19.6633 15.3322 19.1142 18.2838C18.8818 19.5328 18.4244 19.9516 17.9815 19.9926C17.0189 20.0816 16.288 19.3529 15.3558 18.7384C13.897 17.7769 13.0729 17.1783 11.6569 16.24C10.0205 15.1556 11.0813 14.5596 12.0139 13.5856C12.258 13.3307 16.4988 9.45188 16.5809 9.10001C16.5912 9.05601 16.6007 8.89197 16.5038 8.80535C16.4069 8.71873 16.2639 8.74835 16.1606 8.77191C16.0143 8.8053 13.6839 10.3542 9.16938 13.4185C8.5079 13.8753 7.90875 14.0978 7.37193 14.0862C6.78013 14.0733 5.64175 13.7497 4.79548 13.4731C3.75749 13.1338 2.93252 12.9544 3.00436 12.3782C3.04178 12.0781 3.45279 11.7712 4.23741 11.4574Z",
    fill: "#8E97CD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegramIcon.d76c09778d1238efb9cfa6e9206d36bb.svg";
export { ForwardRef as ReactComponent };